import { render, staticRenderFns } from "./ReviewSplitIdConfirmation.vue?vue&type=template&id=b843b594&scoped=true&"
import script from "./ReviewSplitIdConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReviewSplitIdConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSplitIdConfirmation.vue?vue&type=style&index=0&id=b843b594&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b843b594",
  null
  
)

export default component.exports